import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {HomePage} from '../home-page.js';

import {homePageClassicFactory} from './home-page-classic.factory.js';

import PALETTE_SCHEMA from './home-page-classic.palette-schema.yaml';

class HomePageClassicFeature extends AbstractVisualFeature {
    get name() {
        return 'HomePageClassic';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return homePageClassicFactory(PALETTE);
    }
}

new HomePageClassicFeature(HomePage);
